import React from "react";

export function Loader(){
    return (<>
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </>)
}